import React from 'react';
import { useTranslation } from 'react-i18next';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleImage, ArticleSectionHeader } from 'cityads-v3/components/Article';

import classes from './Payments.scss';

export default function Payments(props) {
  const { t } = useTranslation(['PaymentsArticle']);

  return (
    <Article
      title           = {t('title')}
      pageTitle       = {t('pageTitle')}
      pageDescription = {t('pageDescription')}
      pageKeywords    = {t('pageKeywords')}
      {...props}
    >
      {tArray(t, 'p1', 'p')}

      <ArticleImage
        src={require('./img1.jpg')}
        caption={t('imageCaption')}
      />

      <p>
        {t('p2')}
      </p>

      <ArticleSectionHeader>
        01. {t('bankTitle')}
        <img
          className={classes.headerImg}
          src={require('cityads-v3/containers/main/img/publisher/payment-methods/bank.png')}
          alt={t('bankTitle')}
        />
      </ArticleSectionHeader>
      {tArray(t, 'bankText', 'p')}

      <ArticleSectionHeader>
        02. {t('paypalTitle')}
        <img
          className={classes.headerImg}
          src={require('cityads-v3/containers/main/img/publisher/payment-methods/paypal.png')}
          alt={t('paypalTitle')}
        />
      </ArticleSectionHeader>
      {tArray(t, 'paypalText', 'p')}

      <ArticleSectionHeader>
        03. {t('visaMasterCardTitle')}
        <br />
        <img
          className={classes.headerImg}
          src={require('cityads-v3/containers/main/img/publisher/payment-methods/visa.png')}
          alt="Visa"
        />
        <img
          className={classes.headerImg}
          src={require('cityads-v3/containers/main/img/publisher/payment-methods/mastercard.png')}
          alt="MasterCard"
        />
        <img
          className={classes.headerImg}
          src={require('cityads-v3/containers/main/img/publisher/payment-methods/mir.png')}
          alt="Mir"
        />
      </ArticleSectionHeader>
      {tArray(t, 'visaMasterCardText', 'p')}

      <ArticleSectionHeader>
        04. {t('capitalistTitle')}
        <img
          className={classes.headerImg}
          src={require('cityads-v3/containers/main/img/publisher/payment-methods/capitalist.png')}
          alt={t('capitalistTitle')}
        />
      </ArticleSectionHeader>
      {tArray(t, 'capitalistText', 'p')}

      <br />

      <p>
        {t('others')}
      </p>
    </Article>
  );
}
